import React, { useEffect, useMemo, useState } from "react";
import { useTable, useFilters } from "react-table";
import {
  handleBgColor,
  handleGraphLanguages,
  swedishIt,
} from "../../providers/StylingFunc";
import moment from "moment";
import "moment/locale/sv";
import Loader from "react-loader-spinner";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import {
  Container,
  Tabs,
  Tab,
  TabContent,
  Modal,
  Form,
  Button,
} from "react-bootstrap";

import {
  SearchInputContainer,
  SearchInput,
  PrefixIcon,
} from "../../components/styles/nav-style";
import Search from "resources/images/svg/search.svg";
import XlsxIcon from "resources/images/svg/xlsx.svg";

import Alert from "components/Alert";

import DisplayImages from "components/ImagesDisplay";
import DisplayFiles from "components/FilesDisplay";
import DisplayLogs from "components/LogsDisplay";
import ImageSlider from "components/ImageSlider";
import MapGl from "components/Map/MapGl";

import { HorizontalFlex, VerticalFlex } from "pandora/styled";
import { darkGreen, lightTurquoise, veryLightGrey } from "resources/newColors";
import CrossAlt from "resources/images/svg/cross-black.svg";
import {
  Table,
  HeaderSection,
  TableBody,
  TableHead,
  TableRow,
  TableData,
  IconButton,
  Column,
  Row,
  PaginationDiv,
  PaginationItem,
  DownloadButton,
  BasicButton,
  FileLoader,
  StatusCard,
} from "./styled";
import { getNewFileFormat, getWorkerOrderInfo } from "Services/Api";
import {
  imageData,
  userWorkOrderListDto,
  WorkOrderData,
} from "DTO/userWorkOrderListDto";
import LeaseInfo from "components/LeaseInfo";
import { Box, Grid, ListItem, Stack, Tooltip } from "@mui/material";
import WorkOrderTableBody from "components/WorkOrderTableBody";
import { useCtx } from "context/SessionDataContext";
import { CaseModal, MapModal } from "components/Modals";
import { toSorted } from "Utils/Utils";
import { CaseLogType } from "types";
import { DropDown } from "components/DropDown";
import { useAuthCtx } from "context/AuthContext";
import { InfoField } from "components/InfoField";

const filters = [
  {
    label: "Alla Ärenden",
    value: "all",
  },
  {
    label: "Tilldelade",
    value: "assigned",
  },
  {
    label: "Otilldelade",
    value: "unassigned",
  },
  {
    label: "Avvikelser",
    value: "issue",
  },
  {
    label: "Avslutade ärenden",
    value: "done",
  },
  {
    label: "Projekteringar",
    value: "project",
  },
  {
    label: "Ledningsanvisningar",
    value: "cable indication",
  },
];
const EPSG_FORMATS: Array<{ Header: string; Value: number }> = [
  {
    Header: "SWEREF99 TM - EPSG:3006",
    Value: 3006,
  },
  {
    Header: "SWEREF99 1200 - EPSG:3007",
    Value: 3007,
  },
  {
    Header: "SWEREF99 1330 - EPSG:3008",
    Value: 3008,
  },

  {
    Header: "SWEREF99 1500 - EPSG:3009",
    Value: 3009,
  },
  {
    Header: "SWEREF99 1630 - EPSG:3010",
    Value: 3010,
  },
  {
    Header: "SWEREF99 1800 - EPSG:3011",
    Value: 3011,
  },
  {
    Header: "SWEREF99 1415 - EPSG:3012",
    Value: 3012,
  },
  {
    Header: "SWEREF99 1545 - EPSG:3013",
    Value: 3013,
  },
  {
    Header: "SWEREF99 1715 - EPSG:3014",
    Value: 3014,
  },
  {
    Header: "SWEREF99 1845 - EPSG:3015",
    Value: 3015,
  },
  {
    Header: "SWEREF99 2015 - EPSG:3016",
    Value: 3016,
  },
  {
    Header: "SWEREF99 2145 - EPSG:3017",
    Value: 3017,
  },
  {
    Header: "SWEREF99 2315 - EPSG:3018",
    Value: 3018,
  },
  {
    Header: "WG584 - EPSG:4326",
    Value: 4326,
  },
];

const WorkOrders = () => {
  const [activeActive, setActiveActive] = useState<number | string>();
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedCaseId, setSelectedCaseId] = useState<userWorkOrderListDto>();
  const [polygonFromCaseLocation, setPolygonFromCaseLocation] = useState<any>();
  const [networkImages, setNetworkImages] = useState([]);
  const [networkCoords, setNetworkCoords] = useState([]);
  const [selectedUserImage, setSelectedUserImage] = useState<
    imageData[] | []
  >();
  const [selectedUserFiles, setSelectedUserFiles] = useState<
    string[] | undefined
  >();

  const [activeFilter, setActiveFilter] = useState<string>("all");

  const [key, setKey] = useState("lease");
  const [showTekis, setShowTekis] = useState<number>();

  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [imageIndex, setImageIndex] = React.useState(0);
  const [viewport, setViewport] = useState({
    latitude: 59.334591,
    longitude: 18.06324,
    zoom: 8,
    width: "100%",
    height: "45vh",
    margin: "auto",
  });
  const [mobileModal, setMobileModal] = useState(false);
  //useState case logs
  const [caseLogs, setCaseLogs] = useState<Array<CaseLogType>>([]);
  const [epsgFormat, setEpsgFormat] = useState<number | undefined>();

  // regards => search case by id
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [paginatedData, setPaginatedData] = useState<WorkOrderData[]>([]);
  const [ascending, setAscending] = useState<{ target: string; dir: boolean }>({
    target: "WOCaseId",
    dir: false,
  });
  const {
    workOrderListData,
    setAllWorkorders,
    setCurrentWorkOrder,
    currentWorkOrder,
    isMobile,
    changeWorkOrderStatus,
  } = useCtx();
  const { user } = useAuthCtx();

  const removeShowTeki = (e) => {
    const id = e.target.id;
    if (id.indexOf("showteki") === -1 && showTekis != null) setShowTekis(null);
  };

  useEffect(() => {
    document.addEventListener("click", removeShowTeki);
    return function clear() {
      document.removeEventListener("click", removeShowTeki);
    };
  });

  const [pageSize, setPageSize] = useState(20);
  const [numPages, setNumPages] = useState(0);
  const [activeActivePage, setActiveActivePage] = useState(1);

  //******************* */
  const [showExport, setShowExport] = useState(false);
  const [exportFrom, setExportFrom] = useState("");
  const [exportTo, setExportTo] = useState("");
  const [exportChoices, setExportChoices] = useState<{
    cable: boolean;
    project: boolean;
    all: boolean;
  }>({ cable: true, project: true, all: false });
  const [downloadingLoader, setDownloadingLoader] = useState(false);
  const [show, setShow] = useState(false);
  /***************************** */

  useEffect(() => {
    setLoading(true);
    if (workOrderListData.length > 0) orderData();
  }, [activeFilter, pageSize, activeActivePage, workOrderListData, searchTerm]);

  useEffect(() => {
    const newViewport = {
      ...viewport,
      latitude: currentWorkOrder?.Center?.WGS84[0][0] ?? 59.334591,
      longitude: currentWorkOrder?.Center?.WGS84[0][1] ?? 18.06324,
      zoom: 17,
    };
    setViewport(newViewport);

    setPolygonFromCaseLocation(currentWorkOrder?.Geometry);
    if (currentWorkOrder?.network_coords) {
      setNetworkCoords(currentWorkOrder?.network_coords);
    }
    if (currentWorkOrder?.network_urls) {
      setNetworkImages(currentWorkOrder?.network_urls);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkOrder]);

  const setFilter = (value: string) => {
    setActiveFilter(value);
    setActiveActivePage(1);
  };

  const paginateArray = (
    arr: any[],
    pageSize: number
  ): Array<WorkOrderData[]> => {
    const res = [];
    for (let i = 0; i < arr.length; i += pageSize) {
      res.push(arr.slice(i, i + pageSize));
    }
    return res;
  };

  const orderData = () => {
    let filteredDataArr = workOrderListData;
    if (activeFilter !== "all") {
      filteredDataArr = workOrderListData.filter(
        (wO) => wO.Type === activeFilter || wO.Status === activeFilter
      );
    }
    const pDataArr = paginateArray(
      filteredDataArr
        //allow partial/full id searching
        .filter((v) => {
          if (
            searchTerm === "" ||
            v.WOCaseId.toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            return v;
          }
        }),
      pageSize
    );
    setNumPages(pDataArr.length);
    setPaginatedData(pDataArr[activeActivePage - 1]);
    setLoading(false);
  };

  const setSelectedUserData = async (allData) => {
    //TODO FIX THIS!!
    setSelectedUserImage([]);
    setEpsgFormat(undefined);
    setSelectedUserFiles(undefined);
    setSelectedCaseId(allData);

    try {
      const images = await getWorkerOrderInfo(allData._id, allData.WOCaseId);
      let allCaseLogs: Array<CaseLogType> = images ? images.Data.Logs : [];

      setCaseLogs(allCaseLogs);
      const newViewport = {
        ...viewport,
        latitude: images.Data.Center.WGS84[0][0],
        longitude: images.Data.Center.WGS84[0][1],
        zoom: 17,
      };
      setViewport(newViewport);

      if (images.Data.Document) {
        setSelectedUserFiles(images.Data.Document);
      } else {
        setSelectedUserFiles(undefined);
      }
      if (images.Data.ImageData.length) {
        setSelectedUserImage(images.Data.ImageData);
      } else {
        setSelectedUserImage([]);
      }
    } catch (e: any) {
      if (e?.response?.status === 401) {
        localStorage.removeItem("token");
      }
      setSelectedUserImage([]);
      setSelectedUserFiles(undefined);
    }
  };

  const sortWorkorders = (column: string) => {
    const sortDir = ascending.target !== column ? true : !ascending.dir;
    setAllWorkorders(
      [...workOrderListData].sort((a, b) => toSorted(a, b, column, sortDir))
    );
    setAscending({ target: column, dir: sortDir });
  };

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  function openModal() {
    setModalIsOpen(true);
  }

  // workorders table headers
  const COLUMNS = [
    {
      Header: "ID",
      Value: "WOCaseId",
    },
    {
      Header: "Typ",
      Value: "Type",
    },
    {
      Header: "Plats",
      Value: "Location",
    },
    {
      Header: "Startdatum",
      Value: "StartDate",
    },
    {
      Header: "Förfrågare",
      Value: "IquirerEmail",
    },
    {
      Header: "Utsättningsdatum",
      Value: "StatusUpdatedOn",
    },
    {
      Header: "Ansvarig",
      Value: "Assignee",
    },
    {
      Header: "Status",
      Value: "Status",
    },
  ];

  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(() => COLUMNS, []);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useFilters
  );

  const {
    getTableProps,
    // getTableBodyProps,
    // getHeaderGroupProps,
    headerGroups,
    // rows,
    // prepareRow,
  } = tableInstance;

  const _onChange: React.ChangeEventHandler = (e) => {
    e.preventDefault();
    const target = e.target as HTMLInputElement;
    setSearchTerm(target?.value);
  };

  const PaginationA = () => {
    const pages = [];
    for (let index = 1; index <= numPages; index++) {
      pages.push(index);
    }

    const displayPages = [];

    if (numPages <= 7) {
      displayPages.push(...pages);
    } else {
      const currentPage = activeActivePage;
      let startIndex = currentPage - 3;
      let endIndex = currentPage + 3;

      if (startIndex < 1) {
        endIndex += Math.abs(startIndex) + 1;
        startIndex = 1;
      }

      if (endIndex > numPages) {
        startIndex -= endIndex - numPages;
        endIndex = numPages;
      }

      if (startIndex > 1) {
        displayPages.push(1);
        if (startIndex > 2) {
          displayPages.push("...");
        }
      }

      for (let i = startIndex; i <= endIndex; i++) {
        displayPages.push(i);
      }

      if (endIndex < numPages) {
        if (endIndex < numPages - 1) {
          displayPages.push("...");
        }
        displayPages.push(numPages);
      }
    }
    return (
      <>
        <PaginationItem
          onClick={() => setActiveActivePage(activeActivePage - 1)}
        >
          &laquo;
        </PaginationItem>
        {displayPages.map((p) => (
          <PaginationItem
            hoverColor={p === "..."}
            onClick={() => {
              if (p === "...") return;
              setActiveActivePage(p);
            }}
            key={p}
            isActive={activeActivePage === p}
          >
            {p}
          </PaginationItem>
        ))}
        <PaginationItem
          onClick={() => setActiveActivePage(activeActivePage + 1)}
        >
          &raquo;
        </PaginationItem>
      </>
    );
  };

  const handleCloseExport = () => {
    setShowExport(false);
    setExportFrom("");
    setExportTo("");
    setDownloadingLoader(false);
  };
  const handleShowExport = () => setShowExport(true);

  const downloadXlsxFile = async () => {
    try {
      let temp_arr = [];
      const filterdArr = workOrderListData.filter((wo) => {
        const woDate = wo.WOCaseId.slice(0, 8);
        const filterOnType =
          exportChoices.all ||
          (wo.Type === "cable indication" && exportChoices.cable) ||
          (wo.Type === "project" && exportChoices.project);
        if (
          filterOnType &&
          moment(woDate).format("YYYYMMDD") >=
            moment(exportFrom).format("YYYYMMDD") &&
          moment(woDate).format("YYYYMMDD") <=
            moment(exportTo).format("YYYYMMDD")
        ) {
          return wo;
        }
      });
      let user_org = user.org ?? "";
      for (const index of filterdArr) {
        let t_arr = {
          ID: index.WOCaseId,
          Typ: handleGraphLanguages(index.Type) ?? "",
          Plats: index.Location,
          Startdatum: moment(index.StartDate).format("DD MMM YYYY"),
          Förfrågare: index.IquirerEmail,
          Uppdragstagaren: index.Assignee,
          Utsättningsdatum:
            index.StatusUpdatedOn ??
            moment(index?.StatusUpdatedOn).format("DD MMM YYYY"),
          Status: swedishIt(index.Status, index.InquiryType) ?? index.Status,
          Anteckningar: index?.FieldAppComments?.map(
            (note) => note.comment
          ).join(", "),
        };
        temp_arr.push(t_arr);
      }

      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(temp_arr);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, `Rapport ${user_org}${fileExtension}`);
      handleCloseExport();
    } catch (e: any) {
      handleCloseExport();
      console.error(e.message);
    }
  };
  if (workOrderListData.length > 0) {
    return (
      <Box>
        <ImageSlider
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
          imageIndex={imageIndex}
          selectedUserImage={selectedUserImage}
        />
        <Alert
          setError={setShowError}
          setErrorMessage={setErrorMessage}
          showError={showError}
          errorMessage={errorMessage}
        />
        {/* <HorizontalFlex css="height: 100%"> */}

        <Container
          // style={{
          //   alignItems: "center",
          //   height: "100%",
          // }}
          fluid
        >
          <Grid container>
            <Grid item xs={12} md={currentWorkOrder ? 8 : 12}>
              <Box style={{ padding: 0, height: "100%", overflow: "auto" }}>
                <HorizontalFlex
                  css={`
                    ${isMobile
                      ? "flex-direction: column; gap:20px;"
                      : "flex: 1; margin: 20px 0; justify-content: space-between; padding: 0 45px"}
                  `}
                >
                  <DropDown
                    data={filters.map((f) => f.label)}
                    title={filters.find((f) => f.value === activeFilter)?.label}
                    onclick={(item) =>
                      setFilter(filters.find((f) => f.label === item).value)
                    }
                    css={{ width: "200px" }}
                  />
                  <Loader
                    type="ThreeDots"
                    color={darkGreen}
                    height={30}
                    width={50}
                    timeout={100000} //3 secs
                    visible={loading}
                  />
                  <HorizontalFlex>
                    <DropDown
                      data={[20, 50, 100, 200]}
                      onclick={(val) => {
                        setPageSize(val as number);
                        setActiveActivePage(1);
                      }}
                      title="SIDSTORLEK"
                    />
                    <DownloadButton
                      onClick={() => {
                        handleShowExport();
                      }}
                    >
                      <Tooltip
                        title="Exportera som excel fil"
                        placement="bottom"
                        arrow
                        enterDelay={250}
                        leaveDelay={150}
                      >
                        <span>
                          <PrefixIcon
                            src={XlsxIcon}
                            width={30}
                            style={{ margin: 0 }}
                          />
                        </span>
                      </Tooltip>
                    </DownloadButton>
                    {showExport && (
                      <Modal show={showExport} onHide={handleCloseExport}>
                        <Modal.Header closeButton></Modal.Header>
                        <Modal.Body>
                          <Form>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label>Från och med</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Ange start datum"
                                value={exportFrom}
                                onChange={(e) => setExportFrom(e.target.value)}
                              />
                            </Form.Group>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label>Till och med</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Ange slutdatum"
                                value={exportTo}
                                onChange={(e) => setExportTo(e.target.value)}
                              />
                            </Form.Group>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Check
                                checked={exportChoices.cable}
                                disabled={exportChoices.all}
                                inline
                                label="Ledningsanvisningar"
                                type="checkbox"
                                value="cable indication"
                                onClick={() =>
                                  setExportChoices({
                                    ...exportChoices,
                                    cable: !exportChoices.cable,
                                  })
                                }
                              />
                              <Form.Check
                                checked={exportChoices.project}
                                disabled={exportChoices.all}
                                inline
                                label="Projekteringar"
                                type="checkbox"
                                value="project"
                                onClick={() =>
                                  setExportChoices({
                                    ...exportChoices,
                                    project: !exportChoices.project,
                                  })
                                }
                              />
                              <Form.Check
                                checked={exportChoices.all}
                                inline
                                label="Alla Ärenden"
                                type="checkbox"
                                value="all"
                                onClick={() =>
                                  setExportChoices({
                                    ...exportChoices,
                                    all: !exportChoices.all,
                                  })
                                }
                              />
                            </Form.Group>
                          </Form>
                        </Modal.Body>
                        <Modal.Footer>
                          <SearchInputContainer
                            css="
                              background-color: #FFFFFF;
                              color: #06B4C8;
                              border: solid 1px #06B4C8;
                              right: 0px;
                              width: 170px;
                              flex-direction: column;

                              "
                          >
                            <BasicButton
                              disabled={
                                exportFrom === "" ||
                                exportTo === "" ||
                                (exportChoices.cable === false &&
                                  exportChoices.project === false)
                              }
                              css="
                      background-color: #FFFFFF;
                      color: #06B4C8;
                      border: solid 1px rgba(0,0,0,0);
                      display: flex;
                      align-items: center;
                      padding:0px;
                      "
                              type="submit"
                              onClick={() => {
                                setDownloadingLoader(true);
                                setTimeout(() => {
                                  downloadXlsxFile();
                                }, 1500);
                              }}
                            >
                              {downloadingLoader ? (
                                <>
                                  <FileLoader /> Laddar ner
                                </>
                              ) : (
                                <>
                                  Ladda ner
                                  <PrefixIcon width={30} src={XlsxIcon} />
                                </>
                              )}
                            </BasicButton>
                          </SearchInputContainer>
                        </Modal.Footer>
                      </Modal>
                    )}
                  </HorizontalFlex>
                </HorizontalFlex>
                <SearchInputContainer
                  padding={0}
                  style={{
                    borderRadius: "5px",
                  }}
                  css={`
                    ${isMobile && "margin-left: 0px;"}
                  `}
                >
                  <PrefixIcon src={Search} />
                  <SearchInput
                    placeholder="Sök ärende.."
                    onChange={_onChange}
                  />
                </SearchInputContainer>
                {generateTable()}
                {!loading && (
                  <PaginationDiv css="float: center;">
                    <PaginationA />
                  </PaginationDiv>
                )}
              </Box>
            </Grid>
            {currentWorkOrder && !isMobile && (
              <Grid
                item
                xs={12}
                md={4}
                pl={"10px"}
                borderLeft={`1px solid ${veryLightGrey}`}
              >
                <Box
                  style={{
                    position: "sticky",
                    top: "0px",
                    boxSizing: "border-box",
                    alignContent: "center",
                  }}
                >
                  <div className="detailsSidebar">
                    <VerticalFlex
                      id="tabs-container"
                      // css={`
                      // position: relative;
                      // padding: 0 20px;
                      // margin: 20px 0 40px 0;
                      // @media screen and (max-width: 1000px) {
                      //   padding: 0;
                      // }
                      // `}
                    >
                      <Tabs
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        style={{
                          width: "100%",
                          display: "flex",
                          marginTop: 5,
                        }}
                      >
                        <Tab eventKey="lease" title="Karta">
                          <TabContent
                            style={{
                              height: 300,
                              // borderBottom: `1px solid ${veryLightGrey}`,
                            }}
                          >
                            <LeaseInfo
                              {...currentWorkOrder}
                              onChangeWorkOrderStatus={changeWorkOrderStatus}
                              updateLeaseInfo={(wo: WorkOrderData) =>
                                setCurrentWorkOrder(wo)
                              }
                            />
                          </TabContent>
                        </Tab>
                        <Tab eventKey="images" title="Bilder">
                          <TabContent
                            style={{
                              height: 260,
                              marginTop: 30,
                              paddingTop: 20,
                              borderTop: `1px solid ${veryLightGrey}`,
                            }}
                          >
                            <DisplayImages
                              setIsOpen={setModalIsOpen}
                              setImageIndex={setImageIndex}
                              imageProps={selectedUserImage}
                              setError={setShowError}
                              setErrorMessage={setErrorMessage}
                            />
                          </TabContent>
                        </Tab>
                        <Tab eventKey="files" title="Filer">
                          <TabContent
                            style={{
                              height: 260,
                              marginTop: 30,
                              paddingTop: 20,
                              borderTop: `1px solid ${veryLightGrey}`,
                            }}
                          >
                            <DisplayFiles
                              selectedUserFiles={selectedUserFiles}
                              setError={setShowError}
                              setErrorMessage={setErrorMessage}
                            />
                          </TabContent>
                        </Tab>
                        <Tab eventKey="log" title="Logg">
                          <TabContent
                            style={{
                              height: "50vh",
                              overflowY: "auto",
                            }}
                          >
                            {currentWorkOrder && (
                              <DisplayLogs caseLogs={caseLogs} />
                            )}
                          </TabContent>
                        </Tab>
                      </Tabs>
                      <IconButton
                        css={
                          "position: absolute; width: 18px; color: black; height: auto; right: 20px; top: 20px; z-index: 100"
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setSelectedCaseId(null);
                          setActiveActive(null);
                          setCurrentWorkOrder(undefined);
                        }}
                        src={CrossAlt}
                      />
                    </VerticalFlex>
                    <div>
                      <br></br>
                    </div>
                    <div>
                      <br></br>
                    </div>
                    <div>
                      <br></br>
                    </div>
                    <div>
                      {key === "lease" && (
                        <InfoField
                          header="Ladda ner kartdata:"
                          value={
                            <span
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <DropDown
                                data={EPSG_FORMATS}
                                onclick={(item) =>
                                  setEpsgFormat(item as number)
                                }
                                title={
                                  EPSG_FORMATS.find(
                                    (f) => f.Value === epsgFormat
                                  )?.Header ?? "Välj koordinatsystem"
                                }
                                css={{ width: "260px" }}
                              />
                              <Button
                                style={{
                                  padding: "revert",
                                  alignSelf: "center",
                                  margin: "6px 0 6px 0",
                                  borderRadius: "16px",
                                }}
                                disabled={!epsgFormat}
                                onClick={async () => {
                                  await getNewFileFormat({
                                    case_id: currentWorkOrder.WOCaseId,
                                    requested_crs: epsgFormat,
                                  });
                                }}
                              >
                                Ladda ner
                              </Button>
                            </span>
                          }
                        />
                      )}
                    </div>
                    {viewport && key === "lease" && (
                      <MapGl
                        viewport={viewport}
                        setViewport={setViewport}
                        polygonFromCaseLocation={polygonFromCaseLocation}
                        workOrder={currentWorkOrder}
                        networkCoords={networkCoords}
                        networkImages={networkImages}
                        showBigMap={setShow}
                        show={show}
                        openImageModal={(index: number) => {
                          setModalIsOpen(true);
                          setImageIndex(index);
                        }}
                      />
                    )}
                  </div>
                </Box>
              </Grid>
            )}
          </Grid>
        </Container>

        {/* </HorizontalFlex> */}
        {show && (
          <MapModal
            show={setShow}
            setShow={() => setShow(false)}
            viewport={viewport}
            setViewport={setViewport}
            polygonFromCaseLocation={polygonFromCaseLocation}
            workOrder={currentWorkOrder}
            networkCoords={networkCoords}
            networkImages={networkImages}
            openImageModal={(index: number) => {
              setModalIsOpen(true);
              setImageIndex(index);
            }}
          />
        )}
      </Box>
    );
  } else {
    return (
      <VerticalFlex>
        <Row css="height: 100%">
          <Column css={"padding: 0 "}>
            <HorizontalFlex
              css={
                "flex: 1; justify-content: space-between; margin: 20px 0; padding: 0 40px"
              }
            >
              <DropDown
                data={filters.map((f) => f.label)}
                title={filters.find((f) => f.value === activeFilter)?.label}
                onclick={(item) =>
                  setFilter(filters.find((f) => f.label === item).value)
                }
                css={{ width: "200px" }}
              />
              <Loader
                type="ThreeDots"
                color={darkGreen}
                height={30}
                width={50}
                timeout={100000} //3 secs
                visible={loading}
              />
              <DropDown
                data={[20, 50, 100, 200]}
                onclick={(val) => {
                  setPageSize(val as number);
                  setActiveActivePage(1);
                }}
                title="SIDSTORLEK"
              />
            </HorizontalFlex>
            <SearchInputContainer
              padding={0}
              style={{
                borderRadius: "5px",
              }}
            >
              <PrefixIcon src={Search} />
              <SearchInput placeholder="Sök ärende.." onChange={_onChange} />
            </SearchInputContainer>
            {loading ? (
              <HorizontalFlex css="margin-left: 40px; justify-content: center">
                Loading...
              </HorizontalFlex>
            ) : (
              <strong style={{ color: "rgba(1,57,63,1)" }}>
                <br></br>Inga aktuella ärende
              </strong>
            )}
          </Column>
        </Row>
      </VerticalFlex>
    );
  }

  function generateTable() {
    if (isMobile)
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {mobileModal && (
            <CaseModal
              show={mobileModal}
              onHide={() => {
                setMobileModal(false);
                setCurrentWorkOrder(undefined);
              }}
              workorder={currentWorkOrder}
            />
          )}
          <DropDown
            data={columns}
            title={
              columns.find((c) => c.Value === ascending.target)?.Header ??
              "Sortera"
            }
            onclick={(column) => sortWorkorders(column as string)}
          />
          <Stack marginTop={1} spacing={2}>
            {paginatedData?.map((order: WorkOrderData) => {
              return (
                <ListItem
                  key={order.WOCaseId}
                  onClick={() => {
                    setCurrentWorkOrder(order);
                    setMobileModal(true);
                  }}
                  style={{
                    flexDirection: "column",
                    border: "1px solid",
                    borderRadius: "6px",
                    fontSize: "12px",
                    alignItems: "flex-start",
                    background:
                      currentWorkOrder?.WOCaseId === order.WOCaseId &&
                      lightTurquoise,
                  }}
                >
                  {mobileLineText("ID", order.WOCaseId)}
                  {mobileLineText("Typ", handleGraphLanguages(order.Type))}
                  {mobileLineText("Plats", order.Location)}
                  {mobileLineText(
                    "Startdatum",
                    moment(order?.StartDate).format("DD MMM YYYY") ?? ""
                  )}
                  {mobileLineText("Förfrågare", order.IquirerEmail)}
                  {mobileLineText(
                    "Utsättningsdatum",
                    order?.StatusUpdatedOn
                      ? moment(order?.StatusUpdatedOn).format("DD MMM YYYY")
                      : ""
                  )}
                  {mobileLineText("Ansvarig", order.Assignee)}
                  {
                    <StatusCard
                      css={`
                        background-color: ${order?.Approvals?.accepted === false
                          ? handleBgColor("approvals")
                          : handleBgColor(order.Status)};
                      `}
                    >
                      {swedishIt(order.Status, order.InquiryType)}
                    </StatusCard>
                  }
                </ListItem>
              );
            })}
          </Stack>
        </div>
      );
    return (
      <Table key={"main-table"}>
        <TableHead css="position: sticky;top: 0px;background: white;">
          {headerGroups.map((headerGroup) => (
            <TableRow style={{ gap: "6px" }} key={headerGroup.id} header={true}>
              {headerGroup.headers.map((column, index) =>
                currentWorkOrder &&
                (index === 1 || index === 2 || index === 4) ? (
                  <></>
                ) : (
                  <HeaderSection
                    css={`
                      cursor: pointer;
                      ${ascending.target === column.Value &&
                      "text-decoration: underline;"}
                    `}
                    onClick={() => sortWorkorders(column.Value)}
                    {...column.getHeaderProps()}
                    key={column.getHeaderProps().key}
                  >
                    {column.render("Header")}{" "}
                    {ascending.target === column.Value
                      ? ascending.dir
                        ? " ▲"
                        : " ▼"
                      : ""}
                  </HeaderSection>
                )
              )}
            </TableRow>
          ))}
        </TableHead>

        {loading && paginatedData.length < 1 ? (
          <TableBody>
            <TableRow header={true}>
              <TableData colSpan={9}>
                <HorizontalFlex css="margin-left: 40px">
                  Loading...
                </HorizontalFlex>
              </TableData>
            </TableRow>
          </TableBody>
        ) : (
          <>
            {WorkOrderTableBody(
              paginatedData,
              activeActive,
              setActiveActive,
              (data) => {
                setCurrentWorkOrder(data);
                setSelectedUserData(data);
              },
              currentWorkOrder
            )}
          </>
        )}
      </Table>
    );
  }
};

const mobileLineText = (label: string, text: string) => {
  return (
    <p style={{ margin: 0 }}>
      <strong>{label}: </strong>
      {text}
    </p>
  );
};

export default WorkOrders;
